/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import { LocalDate } from '@js-joda/core';
import React, { Component, ReactComponentElement } from 'react';

// ours
import DatePicker from './DatePicker';
import DatePickersViewModel from 'src/types/view-models/date-pickers.view.model';
import FormatService from '../../services/format.service';

// styles
import styles from './DatePickers.module.scss';
import Selectors from 'src/utils/selectors';

export default class DatePickers extends Component<DatePickersViewModel> {
    public override render(): ReactComponentElement<any> {
        const futureOnly: boolean = this.props.futureOnly || true;
        const minDate: string =
            (this.props.minDate && FormatService.formatSqlDate(this.props.minDate)) ||
            (futureOnly && FormatService.formatSqlDate(LocalDate.now()));
        const maxDate: string =
            (this.props.minDate && FormatService.formatSqlDate(this.props.maxDate)) ||
            FormatService.formatSqlDate(LocalDate.now().plusYears(100));

        return (
            <div className={[styles.datePickersContainer, this.props.className].join(' ')}>
                <DatePicker
                    label={this.props.startDateLabel || 'Planned start date'}
                    id={'dateInputStart'}
                    minDate={minDate}
                    maxDate={maxDate}
                    value={FormatService.formatSqlDate(this.props.startDate || LocalDate.now())}
                    onChange={async (date: any) => {
                        if (date.date) {
                            try {
                                await this.props.handleChangeDate(LocalDate.parse(date.date), 'startDate');
                            } catch (e) {
                                console.error(e);
                            }
                        }
                    }}
                    data-cy="startDateInput"
                />
                {!this.props.noEndPicker && (
                    <DatePicker
                        label={this.props.endDateLabel || 'Planned end date'}
                        id={'dateInputEnd'}
                        minDate={minDate}
                        maxDate={maxDate}
                        value={FormatService.formatSqlDate(this.props.endDate || LocalDate.now())}
                        onChange={async (date: any) => {
                            if (date.date) {
                                try {
                                    await this.props.handleChangeDate(LocalDate.parse(date.date), 'endDate');
                                } catch (e) {
                                    console.error(e);
                                }
                            }
                        }}
                        data-cy={Selectors.General.END_YEAR_INPUT}
                    />
                )}
            </div>
        );
    }
}
